import { Moneda, PaisLogo } from 'src/types'
import { HttpAxiosRequest } from './httpAxiosBase'

export const HttpCacheGeneral = {
    getEnpoint: (url = '') => `cache/generales${url}`,

    getMonedas: (): Promise<Moneda[]> => {
        return HttpAxiosRequest.get(HttpCacheGeneral.getEnpoint('/monedas'))
    },

    getPaisLogo: (): Promise<PaisLogo[]> => {
        return HttpAxiosRequest.get(HttpCacheGeneral.getEnpoint('/paises'))
    },

    refreshAll: (): Promise<string[]> => {
        return HttpAxiosRequest.post('cache/refresh', {})
    }
} as const
